@if (links.length) {
  <nav class="compsych-footer__links" aria-label="Footer navigation">
    <ul role="list">
      @for (link of links; track link.id; let first = $first) {
        <li>
          @if (!first) {
            <span class="compsych-footer__divider" aria-hidden="true"></span>
          }
          <button class="compsych-footer__link" type="button" (click)="linkClick.emit(link.id)">{{ link.label }}</button>
        </li>
      }
    </ul>
  </nav>
}

@if (copyright) {
  <p class="compsych-footer__copyright">{{ copyright }}</p>
}
